import React from 'react';
interface BonusCardProps {
  title: string;
  image: string;
  description: string;
  value?: string;
}
export function BonusCard({
  title,
  image,
  description,
  value = 'GRATIS'
}: BonusCardProps) {
  return <div className="flex flex-col bg-[#FFF8E7] border-2 border-[#8B4513] rounded-lg overflow-hidden shadow-lg transform transition-transform hover:scale-[1.02] duration-300" data-id="element-1">
      <div className="relative h-64 overflow-hidden bg-[#2D241E]" data-id="element-2">
        <img src={image} alt={title} className="w-full h-full object-cover opacity-90 hover:opacity-100 transition-opacity duration-500" data-id="element-3" />
        <div className="absolute top-4 right-4 bg-[#7C2D2D] text-[#F4E8D8] px-4 py-1 font-bold font-serif shadow-md transform rotate-2 border border-[#F4E8D8]" data-id="element-4">
          {value} POR HOY
        </div>
      </div>

      <div className="p-6 flex-1 flex flex-col" data-id="element-5">
        <h3 className="font-serif font-bold text-2xl text-[#7C2D2D] mb-3 border-b border-[#8B4513]/20 pb-2" data-id="element-6">
          {title}
        </h3>
        <p className="font-sans text-[#5D4037] leading-relaxed flex-1" data-id="element-7">
          {description}
        </p>
      </div>
    </div>;
}